import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";

const DetailedRequest = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));

  var Details = {
    id: 1,
    name: "ياسر النايف",
    date: "25/12/2020",
    phone: "0968820968",
    relativePhone: "0968820967",
    relativeRelation: "قريب",
    nationality: "سعودي",
    IdOrPassport: "https://via.placeholder.com/200x150",
    Address: "عنوان الإقامة",
    city: "الرياض",
    bulidNum: "2",
    floorNum: "5",
    VehicleType: "نوع المركبة",
    VehicleColor: "أحمر",
    VehicleNum: "رقم المركبة",
    VehicleLicence: "https://via.placeholder.com/200x150",
  };

  return (
    <div className="DetailedRequest-modal" dir="auto">
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-user" aria-hidden="true"></i>
          {translate("delivery-person-name", locale)}:
        </span>
        <span>{Details.name}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-calendar" aria-hidden="true"></i>
          {translate("date-of-join", locale)}:
        </span>
        <span>{Details.date}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-phone" aria-hidden="true"></i>
          {translate("phone-number", locale)}:
        </span>
        <span>{Details.phone}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-phone" aria-hidden="true"></i>
          {translate("relative-phone-number", locale)}:
        </span>
        <span>{Details.relativePhone}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-users" aria-hidden="true"></i>
          {translate("relative-relation", locale)}:
        </span>
        <span>{Details.relativeRelation}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-flag" aria-hidden="true"></i>
          {translate("nationality", locale)}:
        </span>
        <span>{Details.nationality}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-id-badge" aria-hidden="true"></i>
          {translate("id-or-passport", locale)}:
        </span>
        <div>
          <img src={Details.IdOrPassport} />
        </div>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-map-marker" aria-hidden="true"></i>
          {translate("city", locale)}:
        </span>
        <span>{Details.city}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-building" aria-hidden="true"></i>
          {translate("bulding-number", locale)}:
        </span>
        <span>{Details.bulidNum}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-home" aria-hidden="true"></i>
          {translate("floor-number", locale)}:
        </span>
        <span>{Details.floorNum}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-car" aria-hidden="true"></i>
          {translate("vehicle-type", locale)}:
        </span>
        <span>{Details.VehicleType}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-adjust" aria-hidden="true"></i>
          {translate("vehicle-color", locale)}:
        </span>
        <span>{Details.VehicleColor}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-hashtag" aria-hidden="true"></i>
          {translate("vehicle-num", locale)}:
        </span>
        <span>{Details.VehicleNum}</span>
      </div>
      <div className="det-modal-info-row">
        <span>
          <i className="fa fa-id-card" aria-hidden="true"></i>
          {translate("vehicle-license", locale)}:
        </span>
        <div>
          <img src={Details.VehicleLicence} />
        </div>
      </div>
    </div>
  );
};

export default DetailedRequest;
